import { useCallback } from 'react';

import { emptyArray } from 'ui-components/default-props/empty';
import { noop } from 'ui-components/default-props/noop';

import { OrdersSidebarSection } from '../orders-sidebar-section';
import { TagsSectionContent } from './tags-section-content';
import { TagsSectionHeaderContent } from './tags-section-header-content';

/**
 * @typedef {import('../../../../prop-types/tag').TagPropType} Tag
 */

/**
 * @param {object} props
 * @param {boolean} [props.open]
 * @param {(open: boolean) => void} [props.onClick]
 * @param {Tag[]} props.tags
 * @param {Tag[]} [props.selectedTags]
 * @param {(fulfillmentPlanId: string, tagId: string) => void} props.addTag
 * @param {(fulfillmentPlanId: string, tagId: string) => void} props.removeTag
 * @param {string} [props.currentFulfillmentPlanId]
 * @param {object} [props.dragHandleProps]
 * @returns {JSX.Element}
 */
export const TagsSection = ({
  open = false,
  onClick = noop,
  tags,
  selectedTags = emptyArray,
  addTag,
  removeTag,
  currentFulfillmentPlanId = '',
  dragHandleProps,
}) => {
  const onTagToggled = useCallback(
    (tag) => {
      if (selectedTags.indexOf(tag) === -1) {
        addTag(currentFulfillmentPlanId, tag.tagId);
      } else {
        removeTag(currentFulfillmentPlanId, tag.tagId);
      }
    },
    [addTag, currentFulfillmentPlanId, removeTag, selectedTags],
  );

  const onTagRemoved = useCallback(
    (tagName) => {
      const tag = tags.find((t) => t.name === tagName);
      if (tag) {
        removeTag(currentFulfillmentPlanId, tag.tagId);
      }
    },
    [removeTag, currentFulfillmentPlanId, tags],
  );

  const headerContent = (
    <TagsSectionHeaderContent isSectionExpanded={open} onTagToggled={onTagToggled} selectedTags={selectedTags} tags={tags} />
  );

  const sectionContent = <TagsSectionContent onTagToggled={onTagRemoved} selectedTags={selectedTags} />;

  return (
    <OrdersSidebarSection
      dragHandleProps={dragHandleProps}
      headerContent={headerContent}
      isExpanded={open}
      sectionContent={sectionContent}
      toggleIsExpanded={onClick}
    />
  );
};
